import { graphql, useStaticQuery } from 'gatsby';

export const useRtaData = () => {
	const data = useStaticQuery(graphql`
		query {
			contentstackRtaInHomeAppointment {
				seo {
					description
					title
				}
				nrt_content
				page_title
				phone_type_dropdown {
					phone_type
				}
				section_headings
				section_headings_2
				privacy
				contact_me
				opt_in
				top_content {
					heading
					subheading_1
					subheading
					link_text
				}
				find_a_time {
					cant_find_a_time
					mobile_preferences
					preferences
				}
				showroom_banner {
					hands_on
				}
				messages {
					initial
					description
				}
				consultation_types {
					heading
					subheading
					description
				}
			}
		}
	`);

	return data;
};
